<template>
  <div>
    <v-dialog v-model="dialog" eager persistent scrollable max-width="500">
      <v-form ref="CompanyProfileFormRef" @submit.prevent>
        <v-card>
          <v-card-title class="d-flex align-center">
            <span>{{ action }} Head of Agency Details</span>
            <v-spacer></v-spacer>
            <v-btn
              icon="mdi-close"
              variant="text"
              color="white"
              @click="closeD()"
            >
            </v-btn>
          </v-card-title>

          <v-card-text style="max-height: 700px" class="">
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="head_of_agency"
                    label="Name"
                    :rules="[formRules.required]"
                    outlined
                    density="compact"
                    variant="outlined"
                    class="mb-3"
                  />
                </v-col>
                <!-- <v-col cols="12">
                  <v-text-field
                    v-model="contact_person_position"
                    label="Position"
                    :rules="[formRules.required]"
                    outlined
                    density="compact"
                    variant="outlined"
                    class="mb-3"
                  />
                </v-col> -->
                <v-col cols="12">
                  <v-text-field
                    v-model="head_of_agency_contact_no"
                    label="Phone Number"
                    outlined
                    density="compact"
                    variant="outlined"
                    class="mb-3"
                  />
                </v-col>
                <v-col cols="12">
                  <div>Upload E-sign</div>
                  <v-file-upload
                    :rules="[formRules.required]"
                    accept="image/png"
                    v-model="esig_file"
                    density="comfortable"
                    scrim="primary"
                  ></v-file-upload>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>

          <v-card-actions class="pa-2 mr-4">
            <v-spacer></v-spacer>
            <v-btn outlined @click="closeD()">
              <v-icon>mdi-close-circle-outline</v-icon>
              Cancel
            </v-btn>
            <v-btn
              :color="$vuetify.theme.themes.light.submitBtnsGreen"
              class="white--text"
              density="comfortable"
              variant="flat"
              :disabled="btnLoading"
              :loading="btnLoading"
              @click="save()"
            >
              <v-icon>mdi-check-circle</v-icon>
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <fade-away-message-component
      displayType="default"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :type="fadeAwayMessage.type"
    ></fade-away-message-component>
  </div>
</template>

<script>
import eventBus from "@/eventBus";
export default {
  props: {
    data: Object,
    action: String,
    title: String,
    typeToSave: String,
  },
  data() {
    return {
      dialog: false,
      showDatePicker: false,
      btnLoading: false,
      head_of_agency: null,
      head_of_agency_contact_no: null,
      esig_file: null,
      fadeAwayMessage: {
        show: false,
        type: "success",
        header: "Successfully Added!",
        message: "",
        top: 10,
      },
    };
  },
  watch: {
    data: {
      handler(data) {
        this.dialog = true;
        this.initialize();

        if (!data.id) {
          this.initialize();
        }
      },
      deep: true,
    },
  },
  methods: {
    initialize() {
      this.axiosCall("/organization/getInfo", "GET").then((res) => {
        if (res.data) {
          console.log("org", res.data);
          this.head_of_agency = res.data.head_of_agency;
          this.head_of_agency_contact_no = res.data.head_of_agency_contact_no;
        }
      });
    },

    async save() {
      let formValid = await this.$refs.CompanyProfileFormRef.validate();

      if (formValid.valid) {
        if (!this.esig_file) {
          this.btnLoading = false;
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "error";
          this.fadeAwayMessage.message =
            "Please upload E-signature for student evaluation purposes.";
          this.fadeAwayMessage.header = "System Message";
        } else {
          this.btnLoading = true;
          let data = {
            head_of_agency: this.head_of_agency,
            head_of_agency_contact_no: this.head_of_agency_contact_no,
          };

          let fd = new FormData();
          fd.append("data", JSON.stringify(data));
          fd.append("file", this.esig_file);

          this.axiosCall("/organization/updateHeadOfAgency", "PATCH", fd).then(
            (res) => {
              console.log(res);
              if (res.data.status == 200) {
                this.fadeAwayMessage.show = true;
                this.fadeAwayMessage.type = "success";
                this.fadeAwayMessage.message = res.data.msg;
                this.fadeAwayMessage.header = "System Message";
                this.btnLoading = false;
                this.closeD();
              } else {
                this.btnLoading = false;
                this.fadeAwayMessage.show = true;
                this.fadeAwayMessage.type = "error";
                this.fadeAwayMessage.message = res.data.msg;
                this.fadeAwayMessage.header = "System Message";
              }
            },
          );
        }
      }
    },

    closeD() {
      eventBus.emit("closeUpdateHeadofAgencyDialog", true);
      this.btnLoading = false;
      this.dialog = false;
    },

    getPrograms() {
      this.axiosCall("/program", "GET").then((res) => {
        this.programsList = res.data;
      });
    },
  },
};
</script>

<style scoped>
.tbl {
  width: 100%;
  border-collapse: collapse;
}
</style>
